import { render, staticRenderFns } from "./NewArrival.vue?vue&type=template&id=b2553c22&scoped=true"
import script from "./NewArrival.vue?vue&type=script&lang=js"
export * from "./NewArrival.vue?vue&type=script&lang=js"
import style0 from "./NewArrival.vue?vue&type=style&index=0&id=b2553c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2553c22",
  null
  
)

export default component.exports
import {QSpinnerDots} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerDots})
